import { createAction } from 'redux-actions';
import { ACTIONS } from 'const';

export const setSkipLink = createAction(ACTIONS.SET_SKIP_LINK);
export const clearSkipLink = createAction(ACTIONS.CLEAR_SKIP_LINK);



// WEBPACK FOOTER //
// ./src/actions/skip_link.js